import { buildApiUrl } from './apiUrl';

const STORAGE_KEY = 'cti_call_state_diag_buffer_v1';
const MAX_BUFFER_SIZE = 200;

const getStoredUser = () => {
  try {
    const raw = window.localStorage.getItem('cti_admin_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const getToken = () => {
  try {
    return window.localStorage.getItem('cti_admin_token') || null;
  } catch {
    return null;
  }
};

const getAgentId = () => {
  const user = getStoredUser();
  return user?.agent || user?.agentId || user?.username || user?.id || null;
};

const summarizeCallData = (callData) => {
  if (!callData || typeof callData !== 'object') return callData || null;
  return {
    actionId: callData.actionId || callData.action_id || callData.actionid || null,
    callId: callData.callId || callData.call_id || null,
    ariCallId: callData.ari_call_id || callData.ariCallId || null,
    uniqueid: callData.uniqueid || callData.uniqueId || null,
    skill: callData.skill || null,
    dataId: callData.data_id || callData.dataId || null,
    source: callData.source || null,
    state: callData.state || callData.status || null,
    hasSkillData: Boolean(callData.skillData || callData.skilldata),
    hasSkillConfig: Boolean(callData.skillData?.skillConfig)
  };
};

const pushLocalBuffer = (entry) => {
  try {
    const current = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    const next = Array.isArray(current) ? current.slice(-MAX_BUFFER_SIZE + 1) : [];
    next.push(entry);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage can be unavailable; diagnostics should never break UI.
  }
};

export const logCallStateDiagnostic = (event, payload = {}) => {
  if (typeof window === 'undefined') return;

  const entry = {
    event,
    timestamp: new Date().toISOString(),
    url: window.location.pathname,
    agentId: payload.agentId || getAgentId(),
    extension: payload.extension || null,
    correlationId:
      payload.correlationId ||
      payload.actionId ||
      payload.callId ||
      payload.ariCallId ||
      payload.uniqueid ||
      payload.callData?.actionId ||
      payload.callData?.callId ||
      payload.callData?.call_id ||
      null,
    payload: {
      ...payload,
      callData: summarizeCallData(payload.callData),
      previousCallData: summarizeCallData(payload.previousCallData),
      nextCallData: summarizeCallData(payload.nextCallData)
    }
  };

  pushLocalBuffer(entry);
};

export const getBufferedCallStateDiagnostics = () => {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};
